import React from "react";
import Sidebar from "../components/Sidebar";
import TaskList from "../components/tasks/TaskList";

const Home = () => {
  return (
    <div className="container relative">
      <Sidebar />
      <TaskList />
    </div>
  );
};

export default Home;
